import { connect } from "react-redux";
import RTOCaseSave from "./Save";
import { bindActionCreators } from "redux";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    loanApplicationByIdRequest,
    loanApplicationUpdateRequest,
    loanAccountRequest,
    addCaseRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest,
    addB2cCaseLoginWithDealer
} from "../../../../../../services/redux/CarLoan/action";
const mapStateToProps = (state) => ({
    carBrandResponse : state.CarLoan.carBrandResponse,
    carModelResponse : state.CarLoan.carModelResponse,
    carVariantResponse : state.CarLoan.carVariantResponse,
    bankListResponse : state.CarLoan.bankListResponse,
    ucdCaseByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanApplicationUpdateResponse : state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse : state.CarLoan.loanAccountResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    addCaseResponse : state.CarLoan.addCaseResponse,
    newBankDetailsResponse : state.CarLoan.newBankDetailsResponse,
    vehicleDetailsResponse : state.CarLoan.vehicleDetailsResponse,
    b2cCaseLoginAddition: state.CarLoan.addB2cCaseLoginWithDealerResponse
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        documentUploadUrlPublic,
        carBrandRequest,
        carModelRequest,
        carVariantRequest,
        bankListRequest,
        loanApplicationByIdRequest,
        loanApplicationUpdateRequest,
        loanAccountRequest,
        addCaseRequest,
        newBankDetailsRequest,
        vehicleDetailsRequest,
        addB2cCaseLoginWithDealer
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RTOCaseSave);